import React from 'react';
import './StoryPreview.style.scss';

interface IProps {
  title?: string;
  originalIssue?: string;
  handleOnClick?: () => void;
  bookmarked?: boolean;
  skeleton?: boolean;
}

const StoryPreview = (props: IProps) => {
  const { title, originalIssue, handleOnClick, bookmarked, skeleton } = props;
  return (
    <div
      className={`storyPreview--container ${handleOnClick ? 'clickable' : ''}`}
      onClick={handleOnClick}
    >
      <span className={skeleton ? 'skeleton' : ''}>{title}</span>

      <span className={skeleton ? 'skeleton' : ''}>{originalIssue}</span>

      {bookmarked && (
        <span className="material-icons storyPreview--bookmark">star</span>
      )}
    </div>
  );
};

export default StoryPreview;
